import i18n from '@/utils/i18n';
import InsightsHubIcon from '@assets/icons/insights-hub.svg';
import React from 'react';
import { EmptyState } from '@experiences/components/empty-state';
import { useTheme } from '@/contexts/theme-context';

const ICON_SIZE = 32;
const ICON_STROKE_WIDTH = 1;

export const InsightsEmptyState: React.FC = () => {
  const theme = useTheme();

  return (
    <EmptyState
      description={i18n.t('insights_hub.empty_feed_subtitle')}
      iconElement={
        <InsightsHubIcon
          height={ICON_SIZE}
          stroke={theme.sk.color.icon.primary}
          strokeWidth={ICON_STROKE_WIDTH}
          width={ICON_SIZE}
        />
      }
      title={i18n.t('insights_hub.empty_feed_header')}
    />
  );
};
